// Helpers de formatage français (montants, pourcentages, surfaces, code postal).

const FORMAT_EUR = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const FORMAT_NOMBRE = new Intl.NumberFormat('fr-FR', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const FORMAT_NOMBRE_PRECIS = new Intl.NumberFormat('fr-FR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
});

const FORMAT_POURCENTAGE = new Intl.NumberFormat('fr-FR', {
  style: 'percent',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function formatEuros(montant: number | string | null | undefined): string {
  if (montant === null || montant === undefined) return '';
  const n = typeof montant === 'string' ? Number.parseFloat(montant) : montant;
  if (Number.isNaN(n)) return '';
  return FORMAT_EUR.format(n);
}

export function formatNombre(n: number | string | null | undefined, precis = false): string {
  if (n === null || n === undefined) return '';
  const num = typeof n === 'string' ? Number.parseFloat(n) : n;
  if (Number.isNaN(num)) return '';
  return (precis ? FORMAT_NOMBRE_PRECIS : FORMAT_NOMBRE).format(num);
}

/** Format pourcentage à partir d'une valeur 0-1 (0.20 → "20%"). */
export function formatPourcentage(valeur: number | null | undefined): string {
  if (valeur === null || valeur === undefined || Number.isNaN(valeur)) return '';
  return FORMAT_POURCENTAGE.format(valeur);
}

export function formatSurface(m2: number | string | null | undefined): string {
  return `${formatNombre(m2)} m²`;
}

export function formatLineaire(ml: number | string | null | undefined): string {
  return `${formatNombre(ml)} ml`;
}

export function formatTelephoneFr(tel: string): string {
  const cleaned = tel.replace(/\D/g, '');
  if (cleaned.length === 10) {
    return cleaned.match(/.{1,2}/g)?.join(' ') ?? tel;
  }
  return tel;
}

export function formatCodePostal(cp: string): string {
  const cleaned = cp.replace(/\s/g, '');
  if (cleaned.length === 5) return cleaned;
  return cp;
}

/** Tronque un texte à N caractères, ajoute '…' si tronqué. */
export function tronquer(texte: string, longueur: number): string {
  if (texte.length <= longueur) return texte;
  return `${texte.slice(0, longueur - 1)}…`;
}
